export enum UnsubscribeReason {
  NotRelevant = 'NotRelevant',
  Other = 'Other',
  Spam = 'Spam',
  TooManyEmails = 'TooManyEmails',
}
